import React from 'react';
import { useWizard } from 'rhf-wizard';
import clsx from 'clsx';
const Header = () => {
    const { isLastStep, stepNumber, goToStep } = useWizard();
    const HeaderLink = ({ title, id }) => {
        return (React.createElement("li", { className: "nav-item" },
            React.createElement("a", { href: "#", className: clsx("nav-link", { "complete": id < stepNumber }, { "active": id === stepNumber }), onClick: () => {
                    if (id < stepNumber)
                        goToStep(id - 1);
                } }, title)));
    };
    return (React.createElement("div", { className: "modal-header" },
        !isLastStep && (React.createElement("ul", { className: "nav quote-nav" },
            React.createElement(HeaderLink, { id: 1, title: "Location" }),
            React.createElement(HeaderLink, { id: 2, title: "Riba Stages" }),
            React.createElement(HeaderLink, { id: 3, title: "Services" }),
            React.createElement(HeaderLink, { id: 4, title: "File Outputs" }),
            React.createElement(HeaderLink, { id: 5, title: "Expertise Level" }),
            React.createElement(HeaderLink, { id: 6, title: "Tolerance" }),
            React.createElement(HeaderLink, { id: 7, title: "Personal Details" }))),
        React.createElement("button", { type: "button", className: "btn-close btn-secondary", "data-bs-dismiss": "modal", "aria-label": "Close" })));
};
export default Header;
